/*
 * @Date: 2025-05-06 23:38:32
 * @Author: fangruiyi
 * @LastEditors: fangruiyi
 * @Description:
 */
import { defineOverridesPreferences } from '@vben/preferences'

/**
 * @description 项目配置文件
 * 只需要覆盖项目中的一部分配置，不需要的配置不用覆盖，会自动使用默认配置
 * !!! 更改配置后请清空缓存，否则可能不生效
 */
export const overridesPreferences = defineOverridesPreferences({
  // overrides
  app: {
    layout: 'sidebar-nav', // 'mixed-nav' | 'sidebar-nav' |
    defaultHomePath: '/workspace',
    name: import.meta.env.VITE_APP_TITLE,
    preferencesButtonPosition: 'header',
    enablePreferences: true,
    accessMode: 'frontend',
    authPageLayout: 'panel-center',
  },
  logo: {
    source: '/logo.png',
  },
  copyright: {
    companyName: 'BestFulfill',
    companySiteLink: 'https://bestfulfill.com/',
    date: '2025',
  },
  footer: {
    enable: false,
    fixed: true,
  },
  navigation: {
    accordion: false,
  },
  sidebar: {
    fixedButton: false,
  },
  theme: {
    mode: 'auto',
    radius: '0.25',
  },
  widget: {
    refresh: false,
    themeToggle: true,
    notification: false,
    languageToggle: false,
  },
})
